import { z } from 'zod'
import {
  crmEmailParticipantSummarySchema,
} from './crm-email-read'
import {
  crmCompanyReadSideEffectsSchema,
} from './crm-company-read'
import {
  crmMessageExtractionStatusSchema,
  crmMessageMatchStatusSchema,
} from './crm-message-read'

export const CRM_EMAIL_ASSIGN_WRITE_CONTRACT_VERSION = '1.0.0' as const

export const crmEmailAssignRequestSchema = z.object({
  participantId: z.unknown().optional(),
  participant_id: z.unknown().optional(),
  contactId: z.unknown().optional(),
  contact_id: z.unknown().optional(),
  companyId: z.unknown().optional(),
  company_id: z.unknown().optional(),
  gPersonId: z.unknown().optional(),
  g_person_id: z.unknown().optional(),
  gOrganizationId: z.unknown().optional(),
  g_organization_id: z.unknown().optional(),
  markNotRelevant: z.unknown().optional(),
  mark_not_relevant: z.unknown().optional(),
}).passthrough()

export const crmEmailAssignedMessageSchema = z.object({
  id: z.string().min(1),
  matchStatus: crmMessageMatchStatusSchema,
  extractionStatus: crmMessageExtractionStatusSchema,
  companyId: z.string().nullable(),
  contactId: z.string().nullable(),
}).passthrough()

export const crmEmailAssignResponseSchema = z.object({
  contract_version: z.literal(CRM_EMAIL_ASSIGN_WRITE_CONTRACT_VERSION),
  participant: crmEmailParticipantSummarySchema,
  message: crmEmailAssignedMessageSchema,
  outcome: z.enum(['created', 'reused', 'restored']),
  replayed: z.boolean(),
  sideEffects: crmCompanyReadSideEffectsSchema,
}).passthrough()

export const CRM_EMAIL_ASSIGN_WRITE_ERROR_CODES = [
  'CR_VALIDATION_FAILED',
  'CR_PERMISSION_DENIED',
  'CR_AUTH_UNAVAILABLE',
  'CR_MEMBERSHIP_UNAVAILABLE',
  'CR_DOMAIN_UNAVAILABLE',
  'CR_EMAIL_DISABLED',
] as const

export const crmEmailAssignWriteErrorEnvelopeSchema = z.object({
  contract_version: z.string().min(1),
  error: z.object({
    code: z.enum(CRM_EMAIL_ASSIGN_WRITE_ERROR_CODES),
    message: z.string().min(1),
    reference: z.string().min(1),
  }).passthrough(),
}).passthrough()

export type CrmEmailAssignRequest = z.infer<typeof crmEmailAssignRequestSchema>
export type CrmEmailAssignedMessage = z.infer<typeof crmEmailAssignedMessageSchema>
export type CrmEmailAssignResponse = z.infer<typeof crmEmailAssignResponseSchema>
export type CrmEmailAssignWriteErrorCode = (typeof CRM_EMAIL_ASSIGN_WRITE_ERROR_CODES)[number]
export type CrmEmailAssignWriteErrorEnvelope = z.infer<typeof crmEmailAssignWriteErrorEnvelopeSchema>
